import { Icon, cn } from './ui';

// Gedeelde klikbare ranglijst-rij: knop met een optionele rang-badge, een
// naamkolom (naam + evt. extra badge + sub-regels) en een statistiekkolom met
// pijl. De variabele inhoud komt als node binnen zodat RankingView (rijk) en
// FollowingView (eenvoudig) allebei hun eigen invulling houden.
//
// `highlight` markeert de eigen rij; dat gebeurde eerder via een inline style
// object per call-site.
export default function RankingRow({ onClick, ariaLabel, highlight = false, rank, name, nameExtra, sub, stat, id, compact = false }) {
  return (
    <div role="listitem">
    <button
      id={id}
      type="button"
      className={cn(
        'ranking-row group flex w-full cursor-pointer items-center gap-3 px-3 py-3 text-left sm:gap-3.5 sm:px-4',
        compact ? 'rounded-none border-0 shadow-none' : 'rounded-lg border shadow-e1 hover:-translate-y-px hover:shadow-e2',
        'transition-[box-shadow,border-color,transform] duration-150',
        'hover:border-line-strong',
        'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500',
        highlight ? 'border-primary-500 bg-primary-100' : 'border-line bg-surface',
      )}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      {rank}
      <span className="flex min-w-0 flex-1 flex-col gap-0.5">
        <span className="flex items-center gap-2">
          <span className="truncate font-heading text-[17px] font-bold leading-tight text-ink">{name}</span>
          {nameExtra}
        </span>
        {sub && <span className="flex flex-wrap items-baseline gap-x-2.5 gap-y-0.5">{sub}</span>}
      </span>
      <span className={cn('ranking-stat flex min-w-[76px] shrink-0 flex-col items-end gap-px text-right', compact && 'lg:flex-row lg:items-baseline lg:gap-3')}>{stat}</span>
      <span
        className="shrink-0 text-ink-3 transition-transform duration-150 group-hover:translate-x-0.5"
        aria-hidden="true"
      >
        <Icon name="chevronRight" size={18} />
      </span>
    </button>
    </div>
  );
}
